'use client';

import { useSelector } from 'react-redux';

import { selectSessions } from 'src/store/slices/call-slice';

import CallAudioManager from './audio-element-session';

export default function CallAudioManagerWrapper() {
  const sessions = useSelector(selectSessions);

  return <CallAudioManager sessions={sessions} />;
}
